import { render, staticRenderFns } from "./PagePaymentDownload.vue?vue&type=template&id=3b3cf48c"
import script from "./PagePaymentDownload.vue?vue&type=script&lang=js"
export * from "./PagePaymentDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports